export default {
  files: (state, getters) => {
    return state.files
  },
  activeFile: (state, getters) => {
    return state.activeFile
  },
  file: (state, getters) => {
    return getters.files.data.find(f => f._id === getters.activeFile)
  }
}



// WEBPACK FOOTER //
// ./src/app/store/files/getters.js